<div
  tabindex="0"
  class="notification-ring-item-container display-flex w-100"
  [ngClass]="isOdd ? 'odd-row' : ''"
  (click)="select()"
  (keydown.enter)="select()"
>
  <div class="notification-ring-item-content display-flex grid-gap-8 w-100">
    <div class="display-flex justify-content-center align-items-center notification-icon">
      <app-icon *ngIf="icon" [svg]="icon" [iconHeight]="32" [iconWidth]="32"></app-icon>
    </div>
    <div class="display-flex flex-column grid-gap-4 w-100">
      <div class="small-label-caps bold text-color gray11">
        {{ title }}
      </div>
      <div class="text-color gray11" [ngClass]="[notification.wasRead ? 'body-small' : 'body-small-bold']">
        {{ content }}
      </div>
      <div class="pre-title bold text-color gray11 mt-auto">
        {{ footer }}
      </div>
    </div>
    <div class="display-flex flex-column notification-time align-items-end grid-gap-8">
      <button class="clear-button" mat-icon-button (click)="delete($event)" [disabled]="deleteDisabled">
        <app-icon
          *ngIf="!deleteInProgress"
          [svg]="EIcon.CLOSE"
          [iconWidth]="22"
          [iconHeight]="22"
          [iconColor]="deleteDisabled ? EColorPalette.cGray : EColorPalette.cRed2"
        ></app-icon>
        <mat-icon *ngIf="deleteInProgress">
          <mat-spinner color="accent" diameter="22"></mat-spinner>
        </mat-icon>
      </button>
      <app-pill-list
        *ngIf="!notification?.wasRead; else viewed"
        [availableOptions]="['New']"
        [selectable]="false"
        [pillCss]="'pill-states primary-light'"
      ></app-pill-list>
      <div class="pre-title text-color gray11 nowrap">{{ notification.timestamp | timeFromDate }}</div>
    </div>
  </div>
</div>

<ng-template #viewed>
  <app-pill-list
    [availableOptions]="['Viewed']"
    [selectable]="false"
    [disabled]="true"
    [pillCss]="'pill-states gray-light'"
  ></app-pill-list>
</ng-template>
